<template>

    <div class="caption" v-html="title">
    </div>

</template>

<script>
    export default {
        name: 'Caption',
        props: ['title'],
    };
</script>

<style scoped lang="scss">
    .caption{
        max-width: 40rem;
        text-align: right;
        background-color: rgba(0, 0, 0, 0.5);
        padding: 1.5rem 2rem 1.5rem 20rem;
        font-size: 1.5rem;
        color: #ffffff;
        background: linear-gradient(90deg, rgba(0, 0, 0, 0) 20%, rgba(0, 0, 0, 0.1) 40%, rgba(0, 0, 0, 0.3) 60%, rgba(0, 0, 0, 0.7) 100%);
        box-sizing: border-box;
    }
</style>